













import Vue from 'vue';

import LGpx from 'vue2-leaflet-gpx';
import { GpxTrack } from '@/lib/models/gpxTrack';

export default Vue.extend({
  components: {
    LGpx,
  },
  computed: {
    gpxOptions(): (track: GpxTrack) => object {
      return (track: GpxTrack) => {
        return {
          async: true,
          gpx_options: {
            joinTrackSegments: false,
          },
          markers: {
            startIcon: null,
            endIcon: null,
          },
          polyline_options: {
            color: track.color,
            opacity: 0.4,
            weight: track.weight,
          },
        };
      };
    },
  },
});
